export default __webpack_public_path__ + "static/media/Creepster-Regular.7e293887.ttf";